"use strict";
/** Получить значение из куков по имени
 *
 * @param {string} name - имя cookie-файла
 */const getCookie=e=>{e=document.cookie&&document.cookie.match(new RegExp(`(?:^|; )${e.replace(/([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g,"\\$1")}=([^;]*)`));return e?decodeURIComponent(e[1]):null};module.exports=getCookie;
